import { Paper, Table, TableContainer } from '@mui/material'
import React from 'react'

function StyledTableContainer({ children, height, size, pl, pr, width, isStickyHeader, maxHeight }) {
    return (
        <Paper sx={{
            width: width ? width : "100%", overflow: 'hidden', pl: pl, pr: pr,
            ...(maxHeight ? {} : { height: height ? height : "85%" })
        }} elevation={0}>
            <TableContainer sx={{ maxHeight: maxHeight ? maxHeight : "100%" }} >
                <Table aria-label="simple table" size={size || "small"} stickyHeader={isStickyHeader} >
                    {children}
                </Table>
            </TableContainer>
        </Paper>
    )
}
export default StyledTableContainer